<template>
  <div>
    <!-- <v-sheet width="100%" class="d-flex align-center" :class="leibfamilie.blatter * (kachelbreite + abstand) < screenwidth ? 'justify-center' : 'justify-start'">
      <v-sheet :width="leibfamilie.blatter * (kachelbreite + abstand)" height="600px" class="mx-0">
        <v-card class="d-flex justify-center pa-2" flat>
          <stammbaumKnotenAlt
            :sohn="leibfamilie.sohn" 
            :bbr="leibfamilie.bbr"
            :blatter="leibfamilie.blatter"
            :ebene="0"
            :currentBbr="currentBbr"
            :dense="dense"
            :kachelbreite="kachelbreite"
          >
          </stammbaumKnotenAlt>
        </v-card>
      </v-sheet>
    </v-sheet>
    <v-divider></v-divider> -->
    <v-sheet width="100%" class="d-flex align-center " :class="leibfamilie.blatter * (kachelbreite + abstand) < screenwidth ? 'justify-center' : 'justify-start'">
      <v-btn icon @click="downloadSVG"><v-icon>download</v-icon></v-btn>
      <v-sheet width="100%" height="calc(100vh - 170px)" class="mx-0 overflow-hidden">
        <SvgPanZoom
          style="width: 100%; height: calc(100vh - 170px);"
          :zoomEnabled="true"
          :controlIconsEnabled="true"
          :fit="false"
          :center="true"
          @created="registerSvgPanZoom()"
          maxZoom="2"
        >
          <svg id="svgStammbaum" :width="Math.max(leibfamilie.blatter * (kachelbreite + abstand) + 50, windowWidth)" :height="Math.max((endJahr - startJahr + 1) * 64, windowHeight)" class="pa-0 ma-0">
            <stammbaumKnoten
              :sohn="leibfamilie.sohn" 
              :bbr="leibfamilie.bbr"
              :getArrayDepth="leibfamilie.getArrayDepth"
              :blatter="leibfamilie.blatter"
              :ebene="0"
              :currentBbr="currentBbr"
              :dense="dense"
              :kachelbreite="kachelbreite"
              :startJahr="startJahr"
              :xStart="(leibfamilie.blatter * (kachelbreite + abstand)) / 2 - 50"
              :xMin="0"
              :xWidth="leibfamilie.blatter * (kachelbreite + abstand)"
              :xVater="0"
              :yVater="0"
              :collapse="collapse"
            ></stammbaumKnoten>
          </svg>
        </SvgPanZoom>
      </v-sheet>
    </v-sheet>
  </div>
</template>

<script>
  import stammbaumKnotenAlt from '@/module/submodule/stammbaumKnoten'
  import stammbaumKnoten from '@/module/submodule/stammbaumKnotenNeu'
  import SvgPanZoom from 'vue-svg-pan-zoom'
  export default {
    components: {
      stammbaumKnoten,
      stammbaumKnotenAlt,
      SvgPanZoom
    },
    props: ['bbr', 'currentBbr', 'dense', 'collapse'],
    data () {
      return {
        date: '',
        screenwidth: this.$vuetify.breakpoint.width - 56,
        startJahr: new Date().getFullYear(),
        endJahr: 0
      }
    },
    computed: {
      svgHeight () {
        console.log(this.leibfamilie)
        console.log(this.getArrayDepth(this.leibfamilie))
      },
      windowWidth () {
        return window.innerWidth
      },
      windowHeight () {
        return window.innerHeight - 170
      },
      kachelbreite () {
        return this.dense ? 200 : 250
      },
      abstand () {
        return this.dense ? 10 : 18
      },
      leibfamilie () {
        this.blatt = 0
        let grunder
        let bbr = this.bbr
        while (!grunder) {
          if (bbr.leibvater) {
            bbr = this.$store.getters['bbrbbr/bbr'](bbr.leibvater)
          } else {
            grunder = bbr
          }
        }
        let sohn = this.getLeibsohn(bbr.id)
        let blatter = 0
        if (sohn.length === 0) {
          blatter = 1
        } else {
          sohn.forEach(item => {
            blatter += item.blatter
          })
        }
        let leibfamilie = {
          blatter,
          bbr: grunder,
          sohn
        }
        leibfamilie.getArrayDepth = this.getArrayDepth(leibfamilie)
        return leibfamilie
      }
    },
    methods: {
      getLeibsohn (bbrID) {
        let leibsohn = []
        this.$store.getters['bbrbbr/nurBbrbbr'].forEach(bbr => {
          if (bbr.leibvater === bbrID) {
            let sohn = this.getLeibsohn(bbr.id)
            let blatter = 0
            if (sohn.length === 0) {
              blatter = 1
            } else {
              sohn.forEach(item => {
                blatter += item.blatter
              })
            }
            let getArrayDepth = this.getArrayDepth({
              blatter,
              bbr,
              sohn
            })
            leibsohn.push({
              blatter,
              bbr,
              sohn,
              getArrayDepth
            })
          }
        })
        if (leibsohn.length === 0) {
          this.blatt++
        }
        return leibsohn
      },
      downloadSVG (evt) {
        let svgContent = document.getElementById('svgStammbaum').outerHTML
        let blob = new Blob([svgContent], { type: 'image/svg+xml' })
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = 'image.svg'
        link.click()
      },
      getArrayDepth (array) {
        this.startJahr = Math.min(array.bbr.receptionsdatum.substr(0, 4), this.startJahr)
        this.endJahr = Math.max(array.bbr.receptionsdatum.substr(0, 4), this.endJahr)
        if (!array.sohn.length > 0) return 1
        let max = 0
        array.sohn.forEach(item => {
          max = Math.max(max, this.getArrayDepth(item))
        })
        return 1 + max
      }
    }
  }
</script>

<style >
</style>



// WEBPACK FOOTER //
// stammbaum.vue?a5748424